// extracted by mini-css-extract-plugin
export default {"paypalButton":"PayPalButton_paypalButton__9HIIt"};